// ※サーバから返ってきている情報を使っている項目で、ページに反映されないデータもあるので注意
const imgPath = '/static/img/yearluck/y2023/'
const dirKey = 'houen'

const info = {
  name: '法演',
  itemId: 6406,
  lpId: 4, //なければ0
  pkgTitle: '暮れの酉の2022年のあなたの運勢あああああああああああああああ',
  price: 999,
  memberPrice: 500,
  pkgDescription: 'パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。',
  pkgNotice: '',
}

const top = {
  thumbnail: `${imgPath}top/counselor/${dirKey}/top_thumnail.png`,
  pkgTitleImg: `${imgPath}top/counselor/${dirKey}/top_pkg_title_img.png`,
  pkgBackImg: `${imgPath}top/counselor/${dirKey}/top_bg.png`,
}

const input = {
  thumbnail: `${imgPath}input/counselor/${dirKey}/input_thumnail.png`,
  fukiImage: `${imgPath}input/counselor/${dirKey}/input_fuki.png`,
  pkgBackImg: `${imgPath}input/counselor/${dirKey}/bg_topinfo.png`,
  headInfoBgUpp: `${imgPath}input/counselor/${dirKey}/bg_input_headinfo_upper.png`,
  headInfoBgMdl: `${imgPath}input/counselor/${dirKey}/bg_input_headinfo_middle.png`,
}

const result = {
  title: '女性誌で大人気！<br>法演が占う◆2023年の全運勢',
  thumbnail: `${imgPath}result/counselor/${dirKey}/teller_icon_2.png`,
  underThumbnail: `${imgPath}result/counselor/${dirKey}/teller_icon.png`,
  description: '今日は、鑑定に来てくださってありがとうございます。あなたの1年が、気分良く・楽しく過ごせる年になりますように。くわしく占っていきますね。',
  bottomFukiMessage: '鑑定はいかがでしたか？　あなたの新しい1年が幸せに過ごせますように。<br>次は、あなたが生まれ持った「宿命」と「運命の人」について、見ていきますね。',
}

export default {
  info,
  top,
  input,
  result,
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/YearLuck/y2023/data/counselor/pkg06_houen.js